import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import OrgStructureItemsTable from '../../components/orgStructureItems/OrgStructureItemsTable';

const OrgStructureItemsArchive = () => (<WrapperSection><GlobalBreadcrumbs /><OrgStructureItemsTable isArchive /></WrapperSection>);
export default OrgStructureItemsArchive;
